const strings = {

    //Home
    healthlyticsCanada: "Healthlytics Canada Inc.",
    comingSoon: "Coming soon.",
    redirecting: "Redirecting...",

    //Contact Us
    bannerContactUs: "The smart, patient management system.",
    contactUs: "Contact us",
    contactUsDescription: "Have questions? Fill out the form below to contact tech support.",

    //Form
    nameMandatory: "Name*",
    namePlaceholder: "Jane Doe",
    emailMandatory: "Email*",
    emailPlaceholder: "your@gmail.com",
    titleMandatory: "Title*",
    addDescription: "Add a brief description.",
    commentMandatory: "Comment*",
    shareQuestion: "Share your questions or feedback.",

    submitBtn: "Submit",

    //Contact us

    fixAllErrors: "Fix all errors before proceeding. Number of errors:",
    enterName: "Enter your name.",
    invalidEmail: "Invalid email address.",
    enterTitle: "Enter a title.",
    enterComment: "Enter your comment.",

    //Email 
    emailSent: "Email sent! We’ll be in touch soon.",
    errorEmail: "Submission failed",
    errorSubmitting: "Error submitting form:",

    //Reset Password
    resetPassword: "Reset Password",
    resetPasswordSubtitle: "Create a secure password",
    password: "New password*",
    confirmPassword: "Re-enter new password*",
    passwordPlaceholder: "At least 8 characters",
    errorPassword: "Password not valid",
    errorPasswordMismatch: "Passwords do not match",
    successPassword: "Your password has been successfully updated",
    resetPasswordBtn: "Reset password",
}

export default strings;